
const PIover180 = Math.PI / 180;

// obsolete. There's a built-in google maps function to do the same thing
export function distanceFrom(oldlatLng: google.maps.LatLng, newLatLng: google.maps.LatLng): number {
    const EarthRadiusMeters = 6378137.0; // meters
    const lat1 = oldlatLng.lat();
    const lon1 = oldlatLng.lng();
    const lat2 = newLatLng.lat();
    const lon2 = newLatLng.lng();
    const dLat = (lat2 - lat1) * PIover180;
    const dLon = (lon2 - lon1) * PIover180;
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * PIover180) * Math.cos(lat2 * PIover180) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = EarthRadiusMeters * c;
    return d;
}

export function distanceFromLit(oldlatLng: google.maps.LatLngLiteral, newLatLng: google.maps.LatLngLiteral): number {
    const EarthRadiusMeters = 6378137.0; // meters
    const lat1 = oldlatLng.lat;
    const lon1 = oldlatLng.lng;
    const lat2 = newLatLng.lat;
    const lon2 = newLatLng.lng;
    const dLat = (lat2 - lat1) * PIover180;
    const dLon = (lon2 - lon1) * PIover180;
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * PIover180) * Math.cos(lat2 * PIover180) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = EarthRadiusMeters * c;
    return d;
}

function GetPointAtDistancePL(pl: google.maps.Polyline, metres: number): google.maps.LatLng {
    // some awkward special cases
    const path = pl.getPath();
    if (metres === 0) {
        return path.getAt(0);
    }
    if (metres < 0) {
        return null;
    }
    const pathLength = path.getLength();
    if (pathLength < 2) {
        return null;
    }
    let dist = 0;
    let olddist = 0;
    for (var i = 1; (i < pathLength && dist < metres); i++) {
        olddist = dist;
        dist += google.maps.geometry.spherical.computeDistanceBetween(path.getAt(i), path.getAt(i - 1));
    }
    if (dist < metres) {
        return null;
    }
    const p1 = path.getAt(i - 2);
    const p2 = path.getAt(i - 1);
    const m = (metres - olddist) / (dist - olddist);
    // can use google.maps.geometry.spherical.interpolate
    // https://developers.google.com/maps/documentation/javascript/reference/geometry
    return new google.maps.LatLng(p1.lat() + (p2.lat() - p1.lat()) * m, p1.lng() + (p2.lng() - p1.lng()) * m);
}

// Get the given travel mode
export function getTravelMode(tm: string): google.maps.TravelMode {
    // alternate ways of travelling
    if (tm === "b") {
        return google.maps.TravelMode.BICYCLING;
    } else if (tm === "w") {
        return google.maps.TravelMode.WALKING;
    } else if (tm === "t") {
        return google.maps.TravelMode.TRANSIT;
    } else {
        return google.maps.TravelMode.DRIVING;
    }
}

// Given directions, this computes the total distance
export function getTotalDistance(directions: google.maps.DirectionsResult): number {
    const myroute = directions.routes[0];
    const total = myroute.legs.reduce(function (accum, leg) {
        return accum + leg.distance.value;
    }, 0);

    return total;
}

// Given directions, this computes the total duration
export function getTotalDuration(directions: google.maps.DirectionsResult): number {
    const myroute = directions.routes[0];
    const total = myroute.legs.reduce(function (accum, leg) {
        return accum + leg.duration.value;
    }, 0);

    return total;
}

export function getMidPoint(directions: google.maps.DirectionsResult): google.maps.LatLng {
    const distance = getTotalDistance(directions);
    const line = new google.maps.Polyline({
        path: directions.routes[0].overview_path
    });
    return GetPointAtDistancePL(line, distance / 2);
}

